import ContentLoader from 'react-content-loader';
import Container from '../../../../../core/components/atoms/Container';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { Breadcrumbs } from '../../../../../core/components/organism/Breadcrumbs';
import NoContent from '../../../../../core/components/templates/NoContent';
import PracticeEnemDayCard from '../../../components/Enem/DayCard';
import { usePracticeEnemDaySelectionHook } from '../../../hooks/Enem/daySelection';
import { practiceEnemPaths } from '../../../utils/enemDay';

/**
 * Tela de escolha entre o 1º e o 2º dia do simulado.
 *
 * Os dois dias ficam liberados o tempo todo e podem ser feitos em qualquer
 * ordem — não há sequência obrigatória nem janela de aplicação.
 */
const PracticeEnemDaySelection = () => {
  const { data, days, isError, isLoading, breadCrumbsItems, goToDay, goToDayFeedback } =
    usePracticeEnemDaySelectionHook();

  if (isLoading) {
    return (
      <Container>
        <ContentLoader
          backgroundColor={'#a7adba'}
          foregroundColor={'#c0c5ce'}
          viewBox='0 0 500 30'
        >
          <rect x='0' y='2' rx='2' ry='2' width='200' height='15' />
        </ContentLoader>
        <ContentLoader
          backgroundColor={'#a7adba'}
          foregroundColor={'#c0c5ce'}
          viewBox='0 0 500 160'
        >
          <rect x='0' y='2' rx='4' ry='4' width='240' height='150' />
          <rect x='260' y='2' rx='4' ry='4' width='240' height='150' />
        </ContentLoader>
      </Container>
    );
  }

  if (isError) {
    return <NoContent url={practiceEnemPaths.list()} />;
  }

  return (
    <Container>
      <Breadcrumbs items={breadCrumbsItems} />

      <div className='flex flex-col gap-sm pt-5'>
        <Typography type='title' size='h1'>
          {data?.name}
        </Typography>
        <Typography className='text-mono-color-dark'>
          Escolha por qual dia quer começar. Você pode fazer os dois na ordem que
          preferir — o tempo de prova só começa a contar quando você iniciar.
        </Typography>
      </div>

      <ul className='flex flex-col gap-lg pt-8 md:flex-row md:items-stretch'>
        {days.map((summary) => (
          <PracticeEnemDayCard
            key={`enem-day-${summary.day}`}
            summary={summary}
            onStart={goToDay}
            onFeedback={goToDayFeedback}
          />
        ))}
      </ul>
    </Container>
  );
};

export default PracticeEnemDaySelection;
